
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ai-data-services",
      function () {
        return require("private-next-pages/solutions/ai-data-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ai-data-services"])
      });
    }
  